import Badge from 'react-bootstrap/Badge';

const GAME_STATUSES = {
    SETUP: {
        text: "Setup",
        style: "secondary",
        bgColor: "rgba(155, 155, 155, 0.9)"
    },
    ROUND_ACTIVE: {
        text: "Started",
        style: "success",
        bgColor: "rgba(0, 80, 20, 0.9)"
    },
    ROUND_FINISHED: {
        text: "Round finished",
        style: "success",
        bgColor: "rgba(0, 80, 20, 0.9)"
    },
    COMPLETED: {
        text: "Completed",
        style: "dark",
        bgColor: "rgba(80, 80, 80, 0.9)"
    },
};

const GameStatus = ({ status, t }) => {
    const s = GAME_STATUSES[status] || {
        text: "Unknown",
        style: "secondary"
    };
    const statusTranslated = t(`games.status.${status}`)
    return <div><h4><Badge bg={s.style}>{statusTranslated}</Badge></h4></div>
};

export { GAME_STATUSES, GameStatus };